/********************************************************************
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this
 * file in accordance with the terms of the Adobe license agreement
 * accompanying it.
 *******************************************************************/

import { FunctionComponent } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import { UIProvider } from '@adobe-commerce/elsie/components';
import { Lang } from '@adobe-commerce/elsie/i18n';
import { events } from '@adobe-commerce/event-bus';
import { deepmerge } from '@adobe-commerce/elsie/lib';

import en_US from '../i18n/en_US.json';
import { config } from '../api';

// Langs
const langDefinitions = {
  default: en_US,
};

interface CartProviderProps {
  children?: any;
}

export const Provider: FunctionComponent<CartProviderProps> = ({ children }) => {
  const [lang, setLang] = useState<Lang>('en_US');

  const userLangDefinitions = config.getConfig()?.langDefinitions;


  //   Events
  useEffect(() => {
    const localeEvent = events.on(
      'locale',
      (locale: string) => {
        setLang(locale as Lang);
      },
      { eager: true },
    );
    return () => {
      localeEvent?.off();
    };
  }, []);

  // Merge language definitions with user language definitions
  const definitions = deepmerge(langDefinitions, userLangDefinitions ?? {});

  return (
    <UIProvider lang={lang} langDefinitions={definitions}>
      {children}
    </UIProvider>
  );
};
